import type { FaireProductEntity } from "../../entity_types/product";

export const p_gyhcx62b2f: FaireProductEntity = {
  token: "p_gyhcx62b2f",
  type: "product",
  name: "SmartKarton 10\" x 6\" x 4\" All Paper Pack Boxes - Bundle of 25",
  brandToken: "b_ajaj2rm3ar",
  brandName: "Store Supply Warehouse",
  imageUrl: "https://cdn.faire.com/fastly/b69f3f4d810c93635112c4486880d6e7a1ea855fd685431d5786075419a61379.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/974f831802fe4e5043edb5d8e0a02d865b464f787b0b043d6c6da57fe683ccc6.jpeg",
    "https://cdn.faire.com/fastly/e6f4e331e79f6ef50eb55132f0beb2c44ba238426a7c7e1135f517c890ffeb09.jpeg",
    "https://cdn.faire.com/fastly/74c84cb53edc514aabba8de2c5120b98e519298626d50a5c7b0cc220b86be06a.jpeg",
    "https://cdn.faire.com/fastly/ae8a5c75e20182118991498a4e0d3d754441c75e263833d760219f1379d141a4.jpeg",
    "https://cdn.faire.com/fastly/4588ffb2cb7527c91a5655efca5bcf01f37ad88014d14f1667bbf14fcb189310.jpeg",
    "https://cdn.faire.com/fastly/94505d42b80e88c0abc67c961cd56da0970b790209a2b34a1aab591af9614e56.jpeg",
    "https://cdn.faire.com/fastly/ba2367a0b9082048e25e1ec17eb523d6af4ca07475ae10cbc1dd5617e7077ff1.jpeg",
    "https://cdn.faire.com/fastly/3c85344f70004bf2f274554ef17a7058858d496fa5c35ee5bac029347630830f.jpeg"
  ],
  priceDollars: 18.95,
  description: "Simplify packing with the SmartKarton All Paper Pack, a recyclable all-in-one shipping box with a patented paper liner that holds products in place. It cuts down on void fill, plastic fillers and bubble wrap, and keeps orders neat for a clean unboxing.\n\n- Size: 10\" x 6\" x 4\"\n- 100% recyclable, paper-based\n- Patented integrated protective liner\n- Stores flat\n- Quantity: 25 boxes per bundle\n\nHow to pack: place items upside down in the bottom of the box, fold the paper liner down over them, then close the box.",
  tags: [],
  msrpDollars: 28.43,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:19.842Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
